import { lazy } from "react";

const dilutionRoutes = [
  {
    path: "/dilution-staking/normal/battlefield",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/normal-staking/battlefield")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/normal/battlefield/:armyId",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/normal-staking/battlefield-detail")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/normal/:tag",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/normal-staking/detail")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/normal",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/normal-staking")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/limited/create",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/limited-staking/create-vault")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/limited/join/:armyId",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/limited-staking/join-vault")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/limited/withdraw/:armyId",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/limited-staking/withdraw")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/limited/retreat/:armyId",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/limited-staking/retreat")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking/limited",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/limited-staking")),
    animation: "fadeIn",
  },
  {
    path: "/dilution-staking",
    exact: true,
    component: lazy(() => import("../pages/dilution-staking/normal-staking")),
    animation: "fadeIn",
  },
];

const routes = [
  {
    path: "/marketplace/:tab",
    exact: true,
    component: lazy(() => import("../pages/Marketplace")),
    animation: "fadeIn",
  },
  {
    path: "/marketplace/:tab/:tokenId",
    exact: true,
    component: lazy(() => import("../pages/Marketplace")),
    animation: "fadeIn",
  },
  {
    path: "/marketplace/:tab/:ownerAddress/:tokenId",
    component: lazy(() => import("../pages/Marketplace")),
    animation: "fadeIn",
  },
  {
    path: "/chest",
    exact: true,
    component: lazy(() => import("../pages/Chest")),
    animation: "fadeIn",
  },
  {
    path: "/chest/:tab/:version",
    exact: true,
    component: lazy(() => import("../pages/Chest")),
    animation: "fadeIn",
  },
  {
    path: "/inventory",
    exact: true,
    component: lazy(() => import("../pages/inventory2")),
    animation: "fadeIn",
  },
  {
    path: "/inventory/:tab/:version",
    exact: true,
    component: lazy(() => import("../pages/inventory2")),
    animation: "fadeIn",
  },
  {
    path: "/nft-farming",
    exact: true,
    component: lazy(() => import("../pages/ClassicFarming")),
    animation: "fadeIn",
  },
  {
    path: "/heuristic-farming",
    exact: true,
    component: lazy(() => import("../pages/HeuristicFarming")),
    animation: "fadeIn",
  },
  {
    path: "/expedition",
    exact: true,
    component: lazy(() => import("../pages/Expedition")),
    animation: "fadeIn",
  },
  {
    path: "/expedition/:missionId",
    exact: true,
    component: lazy(() => import("../pages/Expedition/MissionDetail")),
    animation: "fadeIn",
  },
  {
    path: "/profile/:userAddress/:tab/:historyTab",
    component: lazy(() => import("../pages/Profile")),
  },
  {
    path: "/profile/:userAddress/:tab",
    component: lazy(() => import("../pages/Profile")),
    animation: "fadeIn",
  },
  {
    path: "/profile/:userAddress",
    component: lazy(() => import("../pages/Profile")),
    animation: "fadeIn",
  },
  {
    path: "/giveaway",
    exact: true,
    component: lazy(() => import("../pages/Giveaway")),
    animation: "fadeIn",
  },
  {
    path: "/giveaway/top-holders",
    exact: true,
    component: lazy(() => import("../pages/Giveaway/Top100Holders")),
    animation: "fadeIn",
  },
  {
    path: "/flash-sale",
    exact: true,
    component: lazy(() => import("../pages/flash-sale")),
    animation: "fadeIn",
  },
  {
    path: "/battle-hand",
    component: lazy(() => import("../pages/Minigame/BattleHand")),
    animation: "fadeIn",
  },
  {
    path: "/treasure-map",
    exact: true,
    component: lazy(() => import("../pages/TreasureMap")),
    animation: "fadeIn",
  },
  {
    path: "/treasure-map/:mapId",
    exact: true,
    component: lazy(() => import("../pages/TreasureMap/MapDetail")),
    animation: "fadeIn",
  },
  {
    path: "/ticket",
    exact: true,
    component: lazy(() => import("../pages/Ticket")),
    animation: "fadeIn",
  },
  {
    path: "/ticket/:tab",
    exact: true,
    component: lazy(() => import("../pages/Ticket")),
    animation: "fadeIn",
  },
  {
    path: "/ticket/:tab/:id",
    exact: true,
    component: lazy(() => import("../pages/Ticket")),
    animation: "fadeIn",
  },
  // {
  //   path: "/bridge",
  //   component: lazy(() => import("../pages/Bridge")),
  //   animation: "fadeIn",
  // },
];

export default routes.concat(dilutionRoutes);
